module.exports = __webpack_public_path__ + "static/fern.e79edbca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fern.jpg
// module id = 487
// module chunks = 114276838955818